<script lang="ts">
  import LetterOrderTag from "../../../../../letter-order-tag"
  let {
    orderTag,
  }: {
    orderTag: {
      label: string
      subLabel?: string | null
      numberLabel: string
      tooltip?: string | null
      tooltipHtml?: boolean
    }
  } = $props()
</script>

<LetterOrderTag tag={orderTag} />
